import {useQuery} from '../../../hooks/QueryHooks';
import {PrivacyPolicyObject} from './FooterType';

const usePrivacy = () => {
	const {data} = useQuery<PrivacyPolicyObject>(`appendices/enterpriser/terms-or-privacy?type=pp`);

	return {data};
};

export default usePrivacy;
